{
  "placeholder": "驗證碼",
  "reloadCAPTCHA": "重新產生驗證碼",
  "playCAPTCHA": "播放驗證碼語音",
  "error": {
    "required": "請輸入驗證碼"
  }
}